import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { FilterDTO } from "../../../datasources/api-client/data-contracts";
import { ApiRoutes } from "../../../datasources/networking/apiRoutes";
import { useWriteResource } from "../../../hooks/useResource";
import { useFiltersRegistry } from "../index";

export const useFilterFavorite = (filterId: string, isFavorite?: boolean) => {

	const { updateFavouriteFilter } = useFiltersRegistry();

	const { isLoading, put, del } = useWriteResource<{}, FilterDTO>(
		{ route: ApiRoutes.PinMenuFilter, path: { id: filterId } }, 
		{ subjectKey: "filter", overwriteErrorMessage: true }
	);

	const toggleFavorite = async () => {
		try {
			if (isFavorite) {
				await del({ actionKey: "put" });
			} else {
				await put({});
			}

			updateFavouriteFilter(filterId, (filter) => ({
				...filter,
				favorite: !filter.favorite,
			}));
		} catch (e) {
			console.log(e);
		}
	};

	return {
		toggleFavorite,
		isLoading,
	};
};
